import React, { useState } from "react";
import { PageHeader } from "../components/PageHeader";
import { Seo } from "../components/Seo";
import { CTABand } from "../components/Layout";
import { GALLERY } from "../data";

const CATEGORIES = ["All", "Kitchen", "Bathroom", "Basement", "Whole-Home", "Exterior"];

const Gallery = () => {
  const [filter, setFilter] = useState("All");
  const items = filter === "All" ? GALLERY : GALLERY.filter((g) => g.category === filter);

  return (
    <div data-testid="gallery-page">
      <Seo
        title="Project Gallery | Bright Oak Renovations"
        description="Browse recent kitchen, bathroom, basement, whole-home and exterior renovation projects completed across Cambridge, Kitchener, Waterloo and Guelph."
        path="/gallery"
      />
      <PageHeader
        label="Portfolio"
        title="Work we're proud to put our name on"
        subtitle="A look at recent renovations across Cambridge, Kitchener, Waterloo and Guelph. Every project reflects our commitment to detail, durability and design."
        testid="gallery-header"
      />

      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="flex flex-wrap gap-3 mb-12" data-testid="gallery-filters">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              data-testid={`gallery-filter-${c.toLowerCase()}`}
              className={`px-6 py-2.5 text-xs font-bold uppercase tracking-widest transition-colors ${
                filter === c
                  ? "bg-[#C68B4E] text-white"
                  : "bg-white border border-[#2B2B2B]/15 text-[#2B2B2B] hover:border-[#C68B4E] hover:text-[#C68B4E]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((g, i) => (
            <div
              key={`${g.title}-${i}`}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden cursor-pointer ${i % 5 === 0 ? "sm:col-span-2 sm:row-span-2" : ""}`}
            >
              <img
                src={g.image}
                alt={g.title}
                className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${i % 5 === 0 ? "h-72 sm:h-full min-h-[300px]" : "h-64"}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2B2B2B]/90 via-[#2B2B2B]/10 to-transparent opacity-70 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-0 left-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform">
                <span className="text-[#C68B4E] text-[0.6rem] font-bold uppercase tracking-[0.2em]">{g.category} · {g.area}</span>
                <h3 className="text-white text-lg font-bold mt-1">{g.title}</h3>
              </div>
            </div>
          ))}
        </div>

        {items.length === 0 && (
          <p className="text-center text-[#5C5C5C] py-16">No projects in this category yet.</p>
        )}
      </section>

      <CTABand />
    </div>
  );
};

export default Gallery;
